export default {
  title: 'Verifique a sua identidade',
  subtitle: 'Introduza os últimos 4 dígitos do telefone do paciente ou do número da encomenda para ver os detalhes da entrega.',
  'type-phone': 'Telefone do paciente (últimos 4 dígitos)',
  'type-order': 'Número da encomenda (últimos 4 dígitos)',
  code: 'Últimos 4 dígitos',
  submit: 'Continuar',
  'attempts-remaining': 'Tentativas restantes: {count}',
  blocked: 'Demasiadas tentativas. Tente novamente dentro de {minutes} min.',
  'invalid-code': 'Código incorreto. Tente novamente.',
  expired: {
    title: 'Ligação expirada',
    description: 'O acesso a esta encomenda já não está disponível (limite de 14 dias).',
  },
  forbidden: {
    title: 'Acesso negado',
    description: 'Não tem permissão para ver esta página.',
  },
}
